import CellHero from "../components/CellHero";
import CellFocus from "../components/CellFocus";
import CellPathwayNav from "../components/CellPathwayNav";
import CellLeadership from "../components/CellLeadership";
import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { Link } from "react-router-dom";

export default function TextileProcessingCellPage() {
  return (
    <main className="min-h-screen">
      <CellHero
        name="Textile Processing Cell"
        tagline="Dyeing, Finishing, and Sustainable Processing Innovation"
        description="The Textile Processing Cell tackles the most resource-intensive and environmentally critical stage of textile manufacturing. It focuses on water reduction, energy efficiency, quality stability, and the introduction of sustainable processing technologies."
        icon="ri-drop-line"
      />

      <CellFocus
        focus={[
          "Dyeing & finishing process optimization",
          "Water, steam & energy reduction",
          "Quality stability & RFT improvement",
          "Sustainable processing innovation",
        ]}
        description="Processing accounts for the bulk of a textile factory's environmental footprint and operational cost. This cell develops practical solutions that reduce resource consumption, improve right-first-time rates, and introduce next-generation sustainable chemistry and machinery."
      />

      <CellLeadership
        chiefCatalyst={{
          name: "Engr. A.S.M Hafizur Rahman Nixon",
          designation: "Executive Director, RH Corporation (Aziz Group)",
        }}
        moderators={[
          {
            name: "Md. Rahat Ullah Rashed",
            designation: "Head Of Technical Support, Taiwan Persotex Corporation",
          },
          {
            name: "Ashraful Alam",
            designation: "Director of Printing, M.N. Dyeing, Printing & Washing Mills Ltd.",
          },
          {
            name: "Engr. Rafat Hasan Chowdhury",
            designation: "Director, Huetech Yarn Ltd.; Ex. DGM, Amber Denim Ltd.",
          },
        ]}
      />

      {/* Related Programmes */}
      <section className="bg-tie-navy py-16 md:py-24">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <ScrollReveal>
              <div className="text-center mb-8 md:mb-12">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-white/10 border border-white/20 mb-4 md:mb-5">
                  <span className="text-xs font-semibold text-white/80 uppercase tracking-wider">
                    / Related Programmes
                  </span>
                </div>
                <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight">
                  Processing Innovation in Action
                </h2>
              </div>
            </ScrollReveal>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {[
                { name: "PIIC", desc: "Processing-focused Innovation Circles for dyeing and finishing", route: "/piic" },
                { name: "PIARC", desc: "Applied research on water, energy, and chemical optimization", route: "/piarc" },
                { name: "Training", desc: "Professional certification for processing engineers and managers", route: "/training" },
                { name: "Expo", desc: "Dyeing & Printing Innovation Expo and Green Sustech showcase", route: "https://www.textileinnovationexpo.com/" },
              ].map((prog, index) => (
                <ScrollReveal key={prog.name} delay={index * 100}>
                  {prog.route.startsWith("http") ? (
                    <a href={prog.route} target="_blank" rel="noopener noreferrer" className="group block p-5 md:p-6 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-tie-teal/30 transition-all duration-300">
                      <h3 className="text-base md:text-lg font-semibold text-white mb-2">{prog.name}</h3>
                      <p className="text-sm text-white/60">{prog.desc}</p>
                      <span className="inline-flex items-center mt-3 text-sm font-medium text-tie-teal-light group-hover:text-tie-teal transition-colors">
                        Visit <i className="ri-external-link-line ml-1.5 text-xs" />
                      </span>
                    </a>
                  ) : (
                    <Link to={prog.route} className="group block p-5 md:p-6 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-tie-teal/30 transition-all duration-300">
                      <h3 className="text-base md:text-lg font-semibold text-white mb-2">{prog.name}</h3>
                      <p className="text-sm text-white/60">{prog.desc}</p>
                      <span className="inline-flex items-center mt-3 text-sm font-medium text-tie-teal-light group-hover:text-tie-teal transition-colors">
                        Learn more <i className="ri-arrow-right-line ml-1.5 text-xs group-hover:translate-x-1 transition-transform" />
                      </span>
                    </Link>
                  )}
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CellPathwayNav />
    </main>
  );
}